module.exports = __webpack_public_path__ + "static/media/picture.18182356.webp";